header-searchbar
  .header-searchbar(class="{props.mobile ? 'sp' : 'pc'}" if="{!state.categoryQuery || state.hasSearchCondition || !!props.shop}")
    form(action="{state.formAction}" accept-charset="UTF-8" method="get")
      input(type="hidden" name="cid" value="{ state.categoryQuery }" if!="{!!state.categoryQuery && !props.shop}")
      input(type="hidden" name="cl" value="{ state.colorQuery }" if="{!!state.colorQuery}")
      input(type="hidden" name="cw" value="{ state.caseWidthQuery }" if="{!!state.caseWidthQuery}")
      input(type="hidden" name="cwr" value="{ state.caseWidthRangeQuery }" if="{!!state.caseWidthRangeQuery}")
      input(type="hidden" name="fn" value="{ state.functionQuery }" if="{!!state.functionQuery}")
      input(type="hidden" name="gid" value="{ state.referenceGroupQuery }" if="{!!state.referenceGroupQuery}")
      input(type="hidden" name="gn" value="{ state.genderQuery }" if="{!!state.genderQuery}")
      input(type="hidden" name="mt" value="{ state.materialQuery }" if="{!!state.materialQuery}")
      input(type="hidden" name="mv" value="{ state.movementQuery }" if="{!!state.movementQuery}")
      input(type="hidden" name="pr" value="{ state.priceRangeQuery }" if="{!!state.priceRangeQuery}")
      input(type="hidden" name="rid" value="{ state.referenceQuery }" if="{!!state.referenceQuery}")
      input(type="hidden" name="st" value="{ state.strapQuery }" if="{!!state.strapQuery}")
      input(type="hidden" name="wp" value="{ state.waterproofsQuery }" if="{!!state.waterproofsQuery}")
      input(type="hidden" name="wpr" value="{ state.waterproofsRangeQuery }" if="{!!state.waterproofsRangeQuery}")
      input(type="hidden" name="sa" value="{ state.keywordQuery }" if!="{!!state.keywordQuery && state.keywordQuery !== '' && (state.categoryQuery && props.mobile )}")
      template(if="{!state.categoryQuery || !props.mobile}")
        img.search-icon(src="{searchIcon}" width="19" height="21" if="{props.mobile}")
        .fields
          input.category-suggest.header-searchbar_field(type="text" name="sa" value="{state.keywordQuery}" placeholder="{state.hasSearchCondition ? '条件内から探す' : props.placeholder}" onkeypress="{onPressKey}" data-autocomplete-url="/categories/search_words")
        button.reset(type="button" onclick="{clickResetKeywordQuery}" if="{props.mobile}")
          img(src=resetImage, height='14' width='14')
        button.header-searchbar_button 検索
    .search-condition(if!="{((!state.categoryQuery && !props.mobile) || state.hasSearchCondition) && !props.shop}")
      template(if="{state.hasSearchCondition}")
        template(if="{props.mobile}")
          .search-condition-header
            .search-condition-header-title スマート検索条件
            button.search-condition-header-reset(href="/watches/" onclick="{clickResetConditionQueries}")
              img.close-icon(src="{closeIcon}")
              .label
                | 選択中条件
                br
                | 全てクリア
          .search-condition-groups
            .search-condition-group(if!="{state.existPriceRanges.length > 0}")
              .search-condition-group-title 価格帯
              .search-condition-group-items
                template(each="{existPriceRange in state.existPriceRanges}")
                  button(data-value="{existPriceRange}" onclick="{clickRemovePriceRange}")
                    img.close-icon(src="{closeIcon}")
                    | { textFromPriceRange(existPriceRange) }
            .search-condition-group(if!="{state.existMaterials.length > 0}")
              .search-condition-group-title 素材
              .search-condition-group-items
                template(each="{existMaterial in state.existMaterials}")
                  button(data-value="{existMaterial}" onclick="{clickRemoveMaterial}")
                    img.close-icon(src="{closeIcon}")
                    | { textFromMaterial(existMaterial) }
            .search-condition-group(if!="{state.existStraps.length > 0}")
              .search-condition-group-title ストラップタイプ
              .search-condition-group-items
                template(each="{existStrap in state.existStraps}")
                  button(data-value="{existStrap}" onclick="{clickRemoveStrap}")
                    img.close-icon(src="{closeIcon}")
                    | { textFromStrap(existStrap) }
            .search-condition-group(if!="{state.existColors.length > 0}")
              .search-condition-group-title 文字盤色
              .search-condition-group-items
                template(each="{existColor in state.existColors}")
                  button(data-value="{existColor}" onclick="{clickRemoveColor}")
                    img.close-icon(src="{closeIcon}")
                    | { textFromColor(existColor) }
            .search-condition-group(if!="{state.existCaseWidths.length > 0 || !!state.existCaseWidthRange}")
              .search-condition-group-title ケースサイズ
              .search-condition-group-items
                template(each="{existCaseWidth in state.existCaseWidths}")
                  button(data-value="{existCaseWidth}" onclick="{clickRemoveCaseWidth}")
                    img.close-icon(src="{closeIcon}")
                    | { textFromCaseWidth(existCaseWidth) }
                template(if="{!!state.existCaseWidthRange}")
                  button(data-value="{state.existCaseWidthRange}" onclick="{clickRemoveCaseWidthRange}")
                    img.close-icon(src="{closeIcon}")
                    | { textFromCaseWidthRange(state.existCaseWidthRange) }
            .search-condition-group(if!="{state.existGenders.length > 0}")
              .search-condition-group-title 性別
              .search-condition-group-items
                template(each="{existGender in state.existGenders}")
                  button(data-value="{existGender}" onclick="{clickRemoveGender}")
                    img.close-icon(src="{closeIcon}")
                    | { textFromGender(existGender) }
            .search-condition-group(if!="{state.existWaterproofses.length > 0 || state.existWaterproofsRanges.length > 0}")
              .search-condition-group-title 防水
              .search-condition-group-items
                template(each="{existWaterproofs in state.existWaterproofses}")
                  button(data-value="{existWaterproofs}" onclick="{clickRemoveWaterproofs}")
                    img.close-icon(src="{closeIcon}")
                    | { textFromWaterproofs(existWaterproofs) }
                template(each="{existWaterproofsRange in state.existWaterproofsRanges}")
                  button(data-value="{existWaterproofsRange}" onclick="{clickRemoveWaterproofsRange}")
                    img.close-icon(src="{closeIcon}")
                    | { textFromWaterproofsRange(existWaterproofsRange) }
            .search-condition-group(if!="{state.existMovements.length > 0}")
              .search-condition-group-title ムーブメント
              .search-condition-group-items
                template(each="{existMovement in state.existMovements}")
                  button(data-value="{existMovement}" onclick="{clickRemoveMovement}")
                    img.close-icon(src="{closeIcon}")
                    | { textFromMovement(existMovement) }
            .search-condition-group(if!="{state.existFunctions.length > 0}")
              .search-condition-group-title ムーブメント拡張機能
              .search-condition-group-items
                template(each="{existFunction in state.existFunctions}")
                  button(data-value="{existFunction}" onclick="{clickRemoveFunction}")
                    img.close-icon(src="{closeIcon}")
                    | { textFromFunction(existFunction) }
        template(if="{!props.mobile}")
          .button-group
            span
              | スマート検索条件：
            template(each="{existPriceRange in state.existPriceRanges}")
              button(data-value="{existPriceRange}" onclick="{clickRemovePriceRange}")
                span x
                | { textFromPriceRange(existPriceRange) }
            template(each="{existMaterial in state.existMaterials}")
              button(data-value="{existMaterial}" onclick="{clickRemoveMaterial}")
                span x
                | { textFromMaterial(existMaterial) }
            template(each="{existStrap in state.existStraps}")
              button(data-value="{existStrap}" onclick="{clickRemoveStrap}")
                span x
                | { textFromStrap(existStrap) }
            template(each="{existColor in state.existColors}")
              button(data-value="{existColor}" onclick="{clickRemoveColor}")
                span x
                | { textFromColor(existColor) }
            template(each="{existCaseWidth in state.existCaseWidths}")
              button(data-value="{existCaseWidth}" onclick="{clickRemoveCaseWidth}")
                span x
                | { textFromCaseWidth(existCaseWidth) }
            template(if="{!!state.existCaseWidthRange}")
              button(data-value="{state.existCaseWidthRange}" onclick="{clickRemoveCaseWidthRange}")
                span x
                | { textFromCaseWidthRange(state.existCaseWidthRange) }
            template(each="{existGender in state.existGenders}")
              button(data-value="{existGender}" onclick="{clickRemoveGender}")
                span x
                | { textFromGender(existGender) }
            template(each="{existWaterproofs in state.existWaterproofses}")
              button(data-value="{existWaterproofs}" onclick="{clickRemoveWaterproofs}")
                span x
                | { textFromWaterproofs(existWaterproofs) }
            template(each="{existWaterproofsRange in state.existWaterproofsRanges}")
              button(data-value="{existWaterproofsRange}" onclick="{clickRemoveWaterproofsRange}")
                span x
                | { textFromWaterproofsRange(existWaterproofsRange) }
            template(each="{existMovement in state.existMovements}")
              button(data-value="{existMovement}" onclick="{clickRemoveMovement}")
                span x
                | { textFromMovement(existMovement) }
            template(each="{existFunction in state.existFunctions}")
              button(data-value="{existFunction}" onclick="{clickRemoveFunction}")
                span x
                | { textFromFunction(existFunction) }
            template(if="{state.hasSearchCondition}")
              button.reset(onclick="{clickResetConditionQueries}") 全条件リセット

  style(type="scss").
    .header-searchbar {
      &.pc {
        form {
          border: 3px solid #d8a740;
          display: flex;
          .fields {
            display: flex;
            flex-grow: 1;
            input,select {
              border: none;
              height: 46px;
              line-height: 46px;
              padding-left: 14px;
            }
            input {
              border-right: 1px solid #b3b3b3;
              font-size: 17px;
              flex-grow: 1;
            }
            select {
              flex-grow: 0;
              appearance: none;
              -webkit-appearance: none;
              width: 144px;
              font-size: 14px;
              overflow: hidden;
              text-overflow: ellipsis;
              padding: 0 7px;
              &.reference {
                width: 174px;
              }
            }
          }
          .header-searchbar_button {
            height: 46px;
            width: 70px;
            border: none;
            font-size: 0;
            background: #d8a740;
            &::before {
              content: '\f002';
              font-family: FontAwesome;
              font-size: 32px;
              color: white;
            }
          }
        }
        .search-condition {
          display: flex;
        }
        .button-group {
          display: flex;
          flex-wrap: wrap;
          column-gap: 3px;
          >span {
            font-size: 14px;
            font-weight: bold;
            min-width: 9em;
            margin-top: 12px;
            display: inline-block;
          }
          button, a {
            display: inline-flex;
            align-items: center;
            border: 0;
            font-size: 14px;
            font-weight: bold;
            padding: 4px 16px;
            border-radius: 10px;
            background: #dedede;
            margin-top: 8px;
            span {
              margin-right: 15px;
              color: #e28500;
              font-size: 14px;
            }
            &.reset {
              background: white;
              border: 2px solid #dedede;
              margin-left: 4px;
              color: #464646;
              font-size: 11px;
              padding: 5px 16px 4px;
              position: relative;
              top: -0.5px;
              cursor: pointer;
            }
          }
        }
      }
      &.sp {
        padding: 0 15px 5.46875vw;
        height: fit-content;
        margin-bottom: 0;
        form {
          display: flex;
          justify-content: space-between;
          position: relative;
          .fields {
            width: 68vw;
          }
          .header-searchbar_field {
            -webkit-appearance: unset;
            border-radius: 0;
            border: 2px solid #dbe0e3;
            padding-left: 10.9375vw;
            font-size: 4.6875vw;
            height: 11.25vw;
            line-height: 11.25vw;
            width: 100%;
            font-weight: 700;
          }
          .header-searchbar_button {
            -webkit-appearance: unset;
            border-radius: 0;
            background: #a1a1a1;
            border: 2px solid #dbe0e3;
            font-size: 5vw;
            width: 20vw;
            height: 11.25vw;
            line-height: 10vw;
            flex-grow: 0;
            color: white;
          }
          .reset {
            display: none; // 一旦非表示
            background: none;
            border: none;
            position: absolute;
            right: 84px;
            top: 11px;
          }
          .search-icon {
            display: block;
            width: 5.9375vw;
            height: 6.5625vw;
            position: absolute;
            top: 2.65625vw;
            left: 2.34375vw;
            z-index: 1;
          }
          +.search-condition {
            margin-top: 5.78125vw;
          }
        }
        .search-condition {
          margin-bottom: 2.19vw;
          &-header {
            display: flex;
            align-items: center;
            &-title {
              color: #6c6c6c;
              font-size: 5.46875vw;
              font-weight: 900;
            }
            .search-condition-header-reset {
              border: solid 0.31vw rgb(17, 89, 48);
              border-radius: 1.56vw;
              width: 28.91vw;
              height: 12.34vw;
              margin-left: auto;
              padding: 1.72vw 1.41vw 1.72vw 2.66vw;
              display: flex;
              align-items: center;
              background: #ffffff;

              .close-icon{
                width: 3.90625vw;
                height: 3.90625vw;
              }
              .label {
                font-size: 3.75vw;
                font-weight: 700;
                margin-left: 1.56vw;
                color: #115930;
                line-height: 1.1;
              }
            }
          }
          &-groups {
            margin-top: 4.375vw;
            border-top: 1px solid #bbbbbb;
          }
          &-group {
            margin-top: 5.78125vw;
            display: flex;
            flex-direction: column;
            &-title {
              color: #7f7f7e;
              font-size: 4.69vw;
              font-weight: 700;
            }
            &-items {
              margin-top: 5vw;
              display: flex;
              flex-wrap: wrap;
              align-items: center;
              column-gap: 4.375vw;
              row-gap: 2vw;
              button {
                border-radius: 1.56vw;
                background-color: rgb(211, 224, 173);
                height: 12.19vw;
                padding: 0 3.13vw;
                display: flex;
                align-items: center;
                font-size: 4.69vw;
                font-weight: 700;
                border: none;
                color: #000000;
                .close-icon{
                  width: 3.90625vw;
                  height: 3.90625vw;
                  margin-right: 5.78vw;
                }
              }
            }
          }
        }
        .button-group {
          >span {
            font-weight: bold;
            position: relative;
            bottom: -1px;
          }
          margin-bottom: 20px;
          button,a {
            display: inline-flex;
            align-items: center;
            border: 0;
            font-size: 9px;
            font-weight: bold;
            padding: 5px 12px 3px;
            border-radius: 10px;
            background: #dedede;
            margin-top: 8px;
            span {
              margin-right: 7px;
              color: #e28500;
              font-size: 11px;
              margin-top: -4px;
            }
            &.reset {
              background: white;
              border: 2px solid #dedede;
              margin-left: 4px;
              color: #464646;
              font-size: 9px;
              padding: 3px 8px 1px 11px;
              position: relative;
              top: 1px;
            }
          }
        }
      }
    }
  script.
    import resetImage from 'tags/smartsearch/x.png'
    import searchIcon from 'tags/smartsearch/search_icon_sp.png'
    import closeIcon from 'tags/smartsearch/close-icon.png'
    import SmartsearchMaster from 'models/smartsearch-master.js'

    const masterData = new SmartsearchMaster()
    const valueFromTarget = (target) => {
      if (target.textContent == 'x' || target.tagName === "IMG") target = target.parentNode
      return target.dataset.value
    }
    const getExistQuery = (key) => {
      const result = (new RegExp('[?&]'+encodeURIComponent(key)+'=([^&]*)')).exec(location.search)
      return (!!result ? result[1] : '')
    }

    export default {
      resetImage,
      searchIcon,
      closeIcon,
      onBeforeMount(props, state) {
        state.formAction = !!props.shop ? '/shops/' + props.shop + '/' : '/watches/'
        state.existPriceRanges = []
        state.existStraps = []
        state.existColors = []
        state.existCaseWidths = []
        state.existGenders = []
        state.existWaterproofses = []
        state.existWaterproofsRanges = []
        state.existMovements = []
        state.existFunctions = []
        state.existMaterials = []
        this.initializeByExistQuery()
      },
      clickRemovePriceRange(e) {
        const value = valueFromTarget(e.target)
        const existPriceRanges = this.state.existPriceRanges.filter( (range) => { return range != value } )
        const priceRangeQuery = existPriceRanges.join(',')
        this.update({
          existPriceRanges,
          priceRangeQuery
        })
        this.submitForm()
      },
      clickRemoveMaterial(e) {
        const value = valueFromTarget(e.target)
        const existMaterials = this.state.existMaterials.filter( (material) => { return material != value } )
        const materialQuery = existMaterials.join(',')
        this.update({
          existMaterials,
          materialQuery
        })
        this.submitForm()
      },
      clickRemoveStrap(e) {
        const value = valueFromTarget(e.target)
        const existStraps = this.state.existStraps.filter( (strap) => { return strap != value } )
        const strapQuery = existStraps.join(',')
        this.update({
          existStraps,
          strapQuery
        })
        this.submitForm()
      },
      clickRemoveColor(e) {
        const value = valueFromTarget(e.target)
        const existColors = this.state.existColors.filter( (color) => { return color != value } )
        const colorQuery = existColors.join(',')
        this.update({
          existColors,
          colorQuery
        })
        this.submitForm()
      },
      clickRemoveCaseWidth(e) {
        const value = valueFromTarget(e.target)
        const existCaseWidths = this.state.existCaseWidths.filter( (caseWidth) => { return caseWidth != value } )
        const caseWidthQuery = existCaseWidths.join(',')
        this.update({
          existCaseWidths,
          caseWidthQuery
        })
        this.submitForm()
      },
      clickRemoveCaseWidthRange(e) {
        this.update({
          existCaseWidthRange: '',
          caseWidthRangeQuery: ''
        })
        this.submitForm()
      },
      clickRemoveGender(e) {
        const value = valueFromTarget(e.target)
        const existGenders = this.state.existGenders.filter( (gender) => { return gender != value } )
        const genderQuery = existGenders.join(',')
        this.update({
          existGenders,
          genderQuery
        })
        this.submitForm()
      },
      clickRemoveWaterproofs(e) {
        const value = valueFromTarget(e.target)
        const existWaterproofses = this.state.existWaterproofses.filter( (waterproofs) => { return waterproofs != value })
        const waterproofsQuery = existWaterproofses.join(',')
        this.update({
          existWaterproofses,
          waterproofsQuery
        })
        this.submitForm()
      },
      clickRemoveWaterproofsRange(e) {
        const value = valueFromTarget(e.target)
        const existWaterproofsRanges = this.state.existWaterproofsRanges.filter( (waterproofsRange) => { return waterproofsRange != value })
        const waterproofsRangeQuery = existWaterproofsRanges.join(',')
        this.update({
          existWaterproofsRanges,
          waterproofsRangeQuery
        })
        this.submitForm()
      },
      clickRemoveMovement(e) {
        const value = valueFromTarget(e.target)
        const existMovements = this.state.existMovements.filter( (movement) => { return movement != value } )
        const movementQuery = existMovements.join(',')
        this.update({
          existMovements,
          movementQuery
        })
        this.submitForm()
      },
      clickRemoveFunction(e) {
        const value = valueFromTarget(e.target)
        const existFunctions = this.state.existFunctions.filter( (func) => { return func != value } )
        const functionQuery = existFunctions.join(',')
        this.update({
          existFunctions,
          functionQuery
        })
        this.submitForm()
      },
      clickResetKeywordQuery(e) {
        this.update({
          keywordQuery: undefined
        })
      },
      clickResetConditionQueries(e) {
        this.update({
          keywordQuery: null,
          priceRangeQuery: null,
          materialQuery: null,
          strapQuery: null,
          colorQuery: null,
          caseWidthQuery: null,
          caseWidthRangeQuery: null,
          genderQuery: null,
          waterproofsQuery: null,
          waterproofsRangeQuery: null,
          movementQuery: null,
          functionQuery: null
        })
        this.submitForm()
      },
      onPressKey(e) {
        if ( e.keyCode !== 13 || ( e.keyCode === 13 && (e.shiftKey === true || e.ctrlKey === true || e.altKey === true) )) {
          return false;
        }
        this.update({
          keywordQuery: e.target.value
        })
        this.submitForm()
      },
      submitForm() {
        if (this.hasSearchCondition()) {
          this.root.querySelector('form').submit()
        } else if (!!this.state.referenceQuery) {
          document.location.href = `/categories/${this.state.categoryQuery}/ref=${this.props.referenceName}/`
        } else if (!!this.state.referenceGroupQuery) {
          document.location.href = `/categories/${this.state.categoryQuery}/group=${this.props.referenceGroupName}/`
        } else if (!!this.state.categoryQuery && !this.state.categoryQuery.includes(',')) {
          document.location.href = `/categories/${this.state.categoryQuery}/`
        } else {
          document.location.href = '/watches/'
        }
      },
      textFromPriceRange(priceRange) {
        let rangeData = undefined
        masterData.priceRangeMasters.forEach( (range, i, a) => {
          if (range.range === priceRange) rangeData = range
        })
        if(!!rangeData) return rangeData.text

        const bottom = priceRange.split('-')[0]
        const top = priceRange.split('-')[1]
        const bottomText = bottom == '0' ? '' : `${Math.floor(Number(bottom) / 10000)}万${(Number(bottom) % 10000 > 0) ? Number(bottom) % 10000 : ''}円`
        const topText = top == '99999999' || top == '999999999' ? '' : `${Math.floor(Number(top) / 10000)}万${(Number(top) % 10000 > 0) ? Number(top) % 10000 : ''}円`
        if (bottomText !== '' && topText !== '' && String(Number(top) - Number(bottom)).match(/^9+$/g) ) {
          return `${bottomText}台`
        }

        if (bottomText === '' && topText !== '') return `${topText}未満`
        if (bottomText !== '' && topText === '') return `${bottomText}以上`
        if (bottomText === '' && topText === '') return '下限なし〜上限なし'
        return bottomText + '〜' + topText
      },
      textFromMaterial(material) {
        let materialData = undefined
        masterData.materialMasters.forEach( (m, i, a) => {
          if (m.material === material) materialData = m
        })
        if(!!materialData) return materialData.text
      },
      textFromStrap(strap) {
        let strapData = undefined
        masterData.strapMasters.forEach( (s, i, a) => {
          if (s.strap === strap) strapData = s
        })
        if(!!strapData) return strapData.text
      },
      textFromColor(color) {
        let colorData = undefined
        masterData.colorMasters.forEach( (c, i, a) => {
          if (c.color === color) colorData = c
        })
        if(!!colorData) return colorData.text
      },
      textFromCaseWidth(caseWidth) {
        let caseWidthData = undefined
        masterData.caseWidthRangeMasters.forEach( (c, i, a) => {
          if (c.caseWidth === caseWidth) caseWidthData = c
        })
        if(!!caseWidthData) return caseWidthData.text
        return `${caseWidth}mm`
      },
      textFromCaseWidthRange(caseWidthRange) {
        const bottom = caseWidthRange.split('-')[0]
        const top = caseWidthRange.split('-')[1]
        const bottomText = bottom === '0' ? '' : bottom + 'mm'
        const topText = top === '1000' ? '' : top + 'mm'
        if(bottomText === '' && topText === '') return '下限なし〜上限なし'

        return bottomText + '〜' + topText
      },
      textFromGender(gender) {
        let genderData = undefined
        masterData.genderMasters.forEach( (g, i, a) => {
          if (g.gender === gender) genderData = g
        })
        if(!!genderData) return genderData.text
      },
      textFromWaterproofs(waterproofs) {
        let waterproofsData = undefined
        masterData.waterproofsMasters.forEach( (w, i, a) => {
          if (w.waterproofs === waterproofs) waterproofsData = w
        })
        if(!!waterproofsData) return waterproofsData.text
        if(waterproofs === 'none') return '防水なし'
      },
      textFromWaterproofsRange(waterproofsRange) {
        const bottom = waterproofsRange.split('-')[0]
        const top = waterproofsRange.split('-')[1]
        const bottomText = bottom === '0' ? '' : bottom + 'm'
        const topText = (top === '10000' || top === '9999') ? '' : top + 'm'
        if(bottomText === '' && topText === '') return '下限なし〜上限なし'
        return bottomText + '〜' + topText
      },
      textFromMovement(movement) {
        let movementData = undefined
        masterData.movementMasters.forEach( (m, i, a) => {
          if (m.movement === movement) movementData = m
        })
        if(!!movementData) return movementData.text
      },
      textFromFunction(func) {
        let functionData = undefined
        masterData.functionMasters.forEach( (f, i, a) => {
          if (f.function === func) functionData = f
        })
        if(!!functionData) return functionData.text
      },
      hasSearchCondition() {
        return !!(this.state.priceRangeQuery || this.state.materialQuery || this.state.strapQuery || this.state.colorQuery || this.state.caseWidthQuery || this.state.caseWidthRangeQuery || this.state.genderQuery || this.state.waterproofsQuery || this.state.waterproofsRangeQuery || this.state.movementQuery || this.state.functionQuery)
      },
      initializeByExistQuery() {
        this.state.categoryQuery = decodeURIComponent(getExistQuery('cid')) || this.props.category
        this.state.referenceGroupQuery = decodeURIComponent(getExistQuery('gid')) || this.props.referenceGroup
        this.state.referenceQuery = decodeURIComponent(getExistQuery('rid')) || this.props.reference
        const priceRangeQuery = decodeURIComponent(getExistQuery('pr'))
        this.state.priceRangeQuery = priceRangeQuery
        this.state.existPriceRanges = priceRangeQuery.length === 0 ? [] : priceRangeQuery.split(',')
        const materialQuery = decodeURIComponent(getExistQuery('mt'))
        this.state.materialQuery = materialQuery
        this.state.existMaterials = materialQuery.length === 0 ? [] : materialQuery.split(',')
        const strapQuery = decodeURIComponent(getExistQuery('st'))
        this.state.strapQuery = strapQuery
        this.state.existStraps = strapQuery.length === 0 ? [] : strapQuery.split(',')
        const colorQuery = decodeURIComponent(getExistQuery('cl'))
        this.state.colorQuery = colorQuery
        this.state.existColors = colorQuery.length === 0 ? [] : colorQuery.split(',')
        const caseWidthQuery = decodeURIComponent(getExistQuery('cw'))
        this.state.caseWidthQuery = caseWidthQuery
        this.state.existCaseWidths = caseWidthQuery.length === 0 ? [] : caseWidthQuery.split(',')
        const caseWidthRangeQuery = decodeURIComponent(getExistQuery('cwr'))
        this.state.caseWidthRangeQuery = caseWidthRangeQuery
        this.state.existCaseWidthRange = caseWidthRangeQuery
        const genderQuery = decodeURIComponent(getExistQuery('gn'))
        this.state.genderQuery = genderQuery
        this.state.existGenders = genderQuery.length === 0 ? [] : genderQuery.split(',')
        const waterproofsQuery = decodeURIComponent(getExistQuery('wp'))
        this.state.waterproofsQuery = waterproofsQuery
        this.state.existWaterproofses = waterproofsQuery.length === 0 ? [] : waterproofsQuery.split(',')
        const waterproofsRangeQuery = decodeURIComponent(getExistQuery('wpr'))
        this.state.waterproofsRangeQuery = waterproofsRangeQuery
        this.state.existWaterproofsRanges = waterproofsRangeQuery.length === 0 ? [] : waterproofsRangeQuery.split(',')
        const movementQuery = decodeURIComponent(getExistQuery('mv'))
        this.state.movementQuery = movementQuery
        this.state.existMovements = movementQuery.length === 0 ? [] : movementQuery.split(',')
        const functionQuery = decodeURIComponent(getExistQuery('fn'))
        this.state.functionQuery = functionQuery
        this.state.existFunctions = functionQuery.length === 0 ? [] : functionQuery.split(',')
        const keywordQuery = decodeURIComponent(getExistQuery('sa'))
        if (keywordQuery) {
          this.state.keywordQuery = keywordQuery.replace('+', ' ')
        }
        this.state.hasSearchCondition = !!(
          priceRangeQuery || materialQuery || strapQuery || colorQuery || caseWidthQuery || caseWidthRangeQuery || genderQuery || waterproofsQuery || waterproofsRangeQuery || movementQuery || functionQuery
        )
      },
      onMounted(props, state) {
        this.root.dispatchEvent(new CustomEvent('udedokei--header-searchbar--mounted'));
      }
    }
